export const SeasonalitySchema = {
  Schema_SeasonalityAdjustment_Property_Name: _TL_('Seasonality adjustment name'),
  Schema_SeasonalityAdjustment_Property_CampaignName: _TL_('Campaign name'),
  Schema_SeasonalityAdjustment_Property_CampaignTypeFilter: _TL_('Campaign type'),
  Schema_SeasonalityAdjustment_Property_DeviceTypeFilter: _TL_('Device type'),
  Schema_SeasonalityAdjustment_Property_AdjustmentPercentage: _TL_('Adjustment percentage'),
  Schema_SeasonalityAdjustment_Property_StartDate: _TL_('Start time'),
  Schema_SeasonalityAdjustment_Property_EndDate: _TL_('End time'),
};
